import {createSlice, Dispatch} from '@reduxjs/toolkit';
import {addToSessionObject, BOOKING_SESSION_KEYS} from "../utils";

export const setPassengers = (body: any) => async (dispatch: Dispatch) => {
    dispatch(passengers(body));
}

export const clearPassengers = () => (dispatch: Dispatch) => {
    dispatch(passengers([]));
}

interface SelectedFlightSlice {
    passengers: any;
}

const initialState = (): SelectedFlightSlice => {
    let sessionData;

    try {
        sessionData = JSON.parse((window as any).sessionStorage.getItem(BOOKING_SESSION_KEYS.PASSENGERS));
        if (!sessionData || !Array.isArray(sessionData.passengers)) sessionData = null;
    } catch (error) {
        sessionData = null;
        console.warn('There was a problem with sessionStorage (passengers)', error);
    }

    return {
        passengers: [],
        ...(sessionData || {}),
    };
};

const stateSlice = createSlice({
    name: 'bookflight/passengers',
    initialState: initialState(),
    reducers: {
        passengers: (state: any, action) => {
            addToSessionObject(BOOKING_SESSION_KEYS.PASSENGERS, "passengers", action.payload);
            state.passengers = action.payload;
        },
    }
});

export const {passengers} = stateSlice.actions;

export default stateSlice.reducer;
